<template>
  <div class="home">
    <div class="header-container">
      <!-- <div class="clearfix" id="login-header">
        <div class="logo" style="background-color: #fff">
          <div style="margin-top: 16px">
            <img
              style="width: 56px; vertical-align: -1em"
              src="../../assets/images/logo_256.png"
            />
            <span style="font-size: 30px">
              宁波国企阳光采购电子交易云平台
            </span>
          </div>
        </div>
      </div> -->
      <div style="padding-top: 32px">
        <img
          style="width: 516px"
          src="../../assets/images/logo_jyfw_516_210@2x.png"
        />
        <span
          style="
            display: block;
            opacity: 0.75;
            font-size: 24px;
            color: #ffffff;
            letter-spacing: 1.8px;
            text-align: center;
          "
          >— {{ SystemName }} —
        </span>
      </div>
      <div class="login-middle-wrap">
        <div id="login-middle">
          <div class="header-login">
            <ul id="one">
              <li
                :class="nTabsactive == 1 ? 'active bga' : 'normal bga'"
                @click="() => (nTabsactive = 1)"
                data-lgtype="1"
              ></li>
              <li
                :class="nTabsactive == 2 ? 'active bgb' : 'normal bgb'"
                @click="
                  () => {
                    nTabsactive = 2;
                    getCAList();
                  }
                "
                data-lgtype="2"
              ></li>
            </ul>
            <div class="tang-pass-login" id="oneA0" v-if="nTabsactive == 1">
              <p
                id="userNameWrapper"
                class="pass-form-item pass-form-item-userName"
              >
                <label
                  id="userNameLabel"
                  class="pass-icon pass-icon-userName"
                ></label>
                <input
                  v-model="loginData.account"
                  onkeypress="if(event.keyCode==13) focusNextInput(this)"
                  type="text"
                  id="tbAccount"
                  placeholder="社会信用代码或联系人手机号码"
                  value=""
                  class="pass-text-input w240"
                  autocomplete="off"
                />
              </p>
              <div class="password-item">
                <label
                  for="ca_password"
                  id="Label1"
                  class="icon password-icon"
                ></label>
                <input
                  id="tbPassword"
                  name="password"
                  v-model="loginData.password"
                  @keyup.enter="login"
                  type="password"
                  class="ca-pass-text-input"
                  placeholder="登录密码"
                  value=""
                />
              </div>
              <div class="d_db">
                <a class="pass-fgtpwd" style="text-decoration: none" href="http://ygcg.nbcqjy.org:8061/page/register/forgotpwd.html">
                  忘记密码？
                </a>
                <a class="pass-fgtpwd" style="text-decoration: none" href="https://ygcg.nbcqjy.org/home">
                  返回首页
                </a>
              </div>
              <p
                id="submitWrapper"
                class="pass-form-item pass-form-item-submit"
              >
                <input
                  type="button"
                  id="btnLogin"
                  @click="login"
                  value="登 录"
                  class="pass-button-submit"
                />
                <input
                  type="button"
                  id="btnreg"
                  @click="registered"
                  value="用户注册"
                  class="pass-button-submit btnreg"
                  style="margin-top: 16px; background-color: #f3ae90"
                />
              </p>
            </div>
            <div id="oneA1" class="tang-pass-login" v-if="nTabsactive == 2">
              <div class="d_d">
                <div class="d_da">
                  <span>证书持有人</span>
                  <select
                    id="slCertList"
                    name="CertList"
                    v-model="loginData.caId"
                    style="width: 204px; height: 24px"
                  >
                    <option
                      v-for="item in CAList"
                      :key="item.certSerial"
                      :value="item.certSerial"
                    >
                      {{ item.certSubjectCn }}
                    </option>
                  </select>
                </div>
                <div class="password-item">
                  <label
                    for="ca_password"
                    id="lbca"
                    class="icon password-icon"
                  ></label>
                  <input
                    id="ca_password"
                    name="ca_password"
                    type="password"
                    v-model="loginData.password"
                    @keyup.enter="calogin"
                    autocompleted="off"
                    class="ca-pass-text-input"
                    placeholder="登录密码"
                  />
                </div>
                <!-- <div class="d_db">
                  <a
                    href="http://manage.z-c-y.com/Framework/Download/DownloadTools.aspx"
                    target="_blank"
                    >CA证书驱动下载</a
                  >
                  <a class="pass-fgtpwd" style="float: right" href=""
                    >忘记密码？</a
                  >
                </div> -->
              </div>
              <p
                id="P5"
                class="pass-form-item pass-form-item-submit"
                style="margin-top: 24px"
              >
                <input
                  type="button"
                  id="btnCALogin"
                  @click="calogin"
                  value="登 录"
                  class="pass-button-submit"
                />
                <input
                  type="button"
                  id="btnreg1"
                  value="用户注册"
                  @click="registered"
                  class="pass-button-submit btnreg"
                />
              </p>
            </div>
            <!-- @*？？？*@
                    @*<div id="pass-phoenix-login" class="tang-pass-login-phoenix" style="left:6px;">
                        <div id="pass-phoenix-list-login" class="pass-phoenix-list clearfix" style="width:275px;">
                            <a href="../../reg/RegistAgreement.aspx" class="pass-fgtpwd" style="color: #ff9933;letter-spacing: 1px;font-weight:bold; margin-left:105px;">用户注册</a>
                        </div>
                        <div class="clear"></div>
                    </div>*@ -->
          </div>
        </div>
      </div>
      <div style="margin-top: 20px">
        <p id="lbCaution" style="color: #ffffff">
          <!-- 技术支持：宁波杰瑞软件有限公司 18968299314 0574-87187195 -->
          技术支持：宁波杰瑞软件有限公司 0574-26877268
        </p>
        <p style="color: #ffffff">阳光采购平台信息技术部：0574-87187195</p>
        <p style="color: #ffffff">技术问题咨询QQ群：627476062 425851404</p>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { JSEncrypt } from 'jsencrypt'
import { login, CAlogin } from "@/api/login";
import axios from "axios";
export default {
  name: "Home",
  data() {
    return {
      nTabsactive: 1,
      loginData: {
        account: "",
        password: "",
        client_id: this.$route.query.client_id,
        redirect_uri: this.$route.query.redirect_uri,
        // ClientSecret: this.$route.query.ClientSecret,
        caId: "",
      },
      SystemName: this.$route.query.SystemName=="交易管理系统"? "交易管理系统": this.$route.query.SystemName=="电子监督系统"? "电子监督系统": "交易管理系统",
      //登录成功后重定向地址
      CAList: [],
    };
  },
  computed: {},
  components: {},
  methods: {
    setCookie(name, value, seconds) {
      seconds = seconds || 0;   //seconds有值就直接赋值，没有为0    
      var expires = "";
      if (seconds != 0) {      //设置cookie生存时间    
        var date = new Date();
        date.setTime(date.getTime() + (seconds * 1000));
        expires = "; expires=" + date.toGMTString();
      }
      document.cookie = name + "=" + escape(value) + expires + "; path=/";   //转码并赋值    
    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';'); //把cookie分割成组    
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]; //取得字符串    
        while (c.charAt(0) == ' ') { //判断一下字符串有没有前导空格    
          c = c.substring(1, c.length); //有的话，从第二位开始取    
        }
        if (c.indexOf(nameEQ) == 0) { //如果含有我们要的name    
          return unescape(c.substring(nameEQ.length, c.length)); //解码并截取我们要值    
        }
      }
      return false;
    },
    login() {
      // console.log(process.env.VUE_APP_BASE_API);
      if (!this.loginData.account) {
        this.$message.error("帐号不能为空");
        return;
      }
      if (!this.loginData.password) {
        this.$message.error("密码不能为空");
        return;
      }
      if(JSON.parse(localStorage.getItem("code"))){
        this.$message.error("已经有登录账号，无法再次登录，请退出登录后重试");
        return;
      }
      axios({
        method: 'get',
        url: process.env.VUE_APP_BASE_API + '/login/GetRSApublicKey',
        params: {}
      }).then((res1) => {
        var key = res1.data;
        this.loginData.password = this.jiami(key, this.loginData.password);
        login(this.loginData)
          .then((res) => {
            localStorage.setItem("code",JSON.stringify(res.message));
            this.setCookie("code",JSON.stringify(res.message));
            window.location.href =
              this.loginData.redirect_uri + "?code=" + res.message;
          })
          .catch((err) => {
            // this.$message.error(err);
            console.log(err);
            let msg = err;
            this.$warning({
              title: "登录失败",
              content: msg,
              okText: "确定",
              centered: true,
              onOk() {
                console.log(err);
                if (
                  typeof err == "string" &&
                  (err.indexOf("未提交") > -1 ||
                    err.indexOf("未审核") > -1 ||
                    err.indexOf("申请修改") > -1 ||
                    err.indexOf("退回修改") > -1)
                ) {
                  window.open(
                    "http://ygcg.nbcqjy.org:8061/login.html?systemName=%E5%8D%95%E4%BD%8D%E4%BF%A1%E6%81%AF%E7%AE%A1%E7%90%86"
                  );
                }
              },
            });
          });
      })
    },
    calogin() {
      CAlogin(this.loginData)
        .then((res) => {
          window.location.href =
            this.loginData.redirect_uri + "?code=" + res.message;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    getCAList() {
      var data =
        '{ "serverName": "{0DADE507-64D6-4306-956A-2ED144FF0ED1}", "funcName": "getCertList", "param": "{\\"filterCondition\\":\\"{\\\\\\"checkOwner\\\\\\":{\\\\\\"serverType\\\\\\":\\\\\\"Agent\\\\\\",\\\\\\"ip\\\\\\":\\\\\\"tsign.tseal.cn\\\\\\",\\\\\\"port\\\\\\":9999}}\\"}" }';

      var config = {
        method: "post",
        url: "https://127.0.0.1:7688/TGCtrlApi",
        headers: {
          "Content-Type": "text/plain",
        },
        data: data,
      };
      var key = "getcalist";
      this.$message.loading({ content: "CA登录初始化中...", key, duration: 0 });
      var that = this;
      axios(config)
        .then(function (response) {
          that.$message.success({ content: "初始化成功", key, duration: 2 });
          var res = response.data;
          if (res.result) {
            res.result = JSON.parse(res.result);
            that.CAList = [];
            for (var i = 0; i < res.result.certData.length; i++) {
              var item = res.result.certData[i];
              that.CAList.push({
                certSerial: item.certSerial,
                certSubjectCn: item.certSubjectCn,
              });
            }
          }
        })
        .catch(function (error) {
          that.$message.error({
            content: "请检查是否正确安装并打开天谷客户端服务",
            key,
            duration: 2,
          });
          console.log(error);
        });
    },
    registered() {
      window.open(
        "http://ygcg.nbcqjy.org:8061/page/register/registagreement.html"
      );
    },
    jiami(pubkey,password) {
      var encrypt = new JSEncrypt();
      encrypt.setPublicKey(pubkey);
      var encrypted = encrypt.encrypt(password);
      return encrypted
    }
  },
  mounted:function(){
    if (window.ActiveXObject || "ActiveXObject" in window){
      alert("暂不支持ie浏览器,请使用chrome，edge，360安全浏览器等现代浏览器")
    }
    var state = this.$route.query.state;
    // console.log(state);
    if(state==1){
    // console.log('code：'+state);
      JSON.parse(localStorage.clear("code"))
    }
    if(!this.getCookie('code')){
    //清除
      JSON.parse(localStorage.clear("code"))
    }
    var code = JSON.parse(localStorage.getItem("code"));
    if(code){
        window.location.href = "http://ygcg.nbcqjy.org:8059/Main.html";
    }
  }
};
</script>
<style lang="less" scoped>
@import "./login.less";
</style>
